export default __webpack_public_path__ + "static/media/leftJoystickArrow.9da27c35.svg";